export var timeoutPromise = function (timeout, promise) {
    return new Promise(function (resolve, reject) {
        promise.then(resolve);
        setTimeout(function () {
            reject('timeout');
        }, timeout);
    });
};
//# sourceMappingURL=index.js.map